<template>
    <div>
        <div v-if="loading" style="border: 2px solid var(--v-primary-base);padding:20px;text-align:center">
            <v-progress-circular indeterminate color="var(--v-primary-base)"></v-progress-circular>
        </div>
        <div v-else-if="entities && entity_type" style="border: 2px solid var(--v-primary-base);padding:3px">
            <GenericTableEditableComponent
                    :data="entities_data"
                    :headers="headers"
                    :editable_fields="editable_fields"
                    @change="(data) => updateInstances(data)"
                    :loading="loading_save" >
            </GenericTableEditableComponent>
        </div>
    </div>
</template>
  
<script>
import GenericTableEditableComponent from '@/components/GenericTableEditableComponent.vue'
import RecursivePayloadOnSchemaEditor from '@/modules/entities/infra/RecursivePayloadOnSchemaEditor.vue'
import { EntityInstanceApiRepository, EntityTypeApiRepository } from '@/modules/entities/infra/EntitiesApiRepositories'
export default {
      name: "ListOfInstancesEditor",
      components: {
        RecursivePayloadOnSchemaEditor,
        GenericTableEditableComponent
      },
      inject: ['registerSave'],
      data() {
        return {
            entity_inst_repo: null,
            entity_type_repo: null,
            entities: null,
            entity_type: null,
            loading: true,
            loading_save: false,
        }
      },
      props: {
        entity_instances_ids: {
          type: Array,
          required: true,
        },
        intern_key: {
          type: String,
          required: false,
          default: '',
        },
      },
      async mounted() {
        this.entity_inst_repo = new EntityInstanceApiRepository();
        this.entity_type_repo = new EntityTypeApiRepository();
        await this.loadEntity();
        this.registerSave(this.saveInstances)
        
      },
      methods: {
        async loadEntity(){
            this.loading = true;
            this.entities = await this.entity_inst_repo.get_multiple_instances(this.entity_instances_ids);
            this.entity_type = await this.entity_type_repo.get_type_by_id(this.entities[0].entity_type_id, true);
            this.loading = false;
            // console.log('entities')
            // console.log(this.entities)
            // console.log('type')
            // console.log(this.entity_type)

          //this.composed_key = this.key_to_show + ' ('+this.entity_type.name+')';
        },
        async updateInstances(data){
          console.log('updateInstances')
          console.log(data)
          for(let payload of data){
              let entity = this.entities.find(entity => entity.uuid === payload.uuid);
              const { uuid, ...rest } = payload;
              entity.payload = rest;
              
          }
        },
        async saveInstances(){
          this.loading_save = true;
          await this.entity_inst_repo.update_multiple_instances(this.entities);
          this.loading_save = false;
        },
        get_title_from_key(key){
            return this.entity_type.schema.properties[key].title || key;
        },

        get_type_from_key(key){
            return this.entity_type.schema.properties[key].type || 'string';
        }

      },
      computed: {
        headers(){
            if (this.entity_type && this.entity_type.schema && this.entity_type.schema.required && this.entity_type.schema.required.length != 0){
              return this.entity_type.schema.required.map(key => ({ text: this.get_title_from_key(key), value: key , type:this.get_type_from_key(key) }));
            }
            else {
              return []
            }
        },
        entities_data(){
            return this.entities.map(entity => {
                return {
                    ...entity.payload,
                    uuid: entity.uuid
                }
            });
        },
        editable_fields(){
            if (this.intern_key.endsWith('_e')){
              return this.headers.map(header => header.value)
            }
            let editables = this.headers.map(header => header.value).filter(key => key.endsWith('_e'));//mantinc old ways
            if ( this.entity_type && this.entity_type.ui_config && this.entity_type.ui_config.editable_fields){
              editables.push(...this.entity_type.ui_config.editable_fields)
            }
            return editables
        }
      }
      
    };
</script>

<style scoped>
    .nested-section {
      padding-left: 10px;
      /*border-left: 1px solid #ccc; */
      margin-top: 10px;
    }
</style>
    